import React, { Component } from "react";
import PropTypes from "prop-types";
import "./style.css";

// const buttonStyle = {
//     border: 'none',
//     padding: 0,
//     fontSize: '1.2rem',
//     background: 'inherit',
//     color: 'white',
//     cursor: 'pointer',
// }

const modalBackground = {
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  background: "transparent",
  zIndex: "99999"
};

const modalDialog = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  background: "white",
  overflow: "hidden",
  borderRadius: "10px",
  // top: '20%',
  // left: '10%',
  // right: '10%',
  // bottom: '20%',
  // textAlign: 'center',
  // backgroundColor: 'rgba(250, 250, 250, 1)',
  boxShadow: "0 5px 20px rgba(00,00,00, 0.16)",
  zIndex: "99999"
};

const modalFullDialog = {
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  // textAlign: 'center',
  // backgroundColor: 'rgba(250, 250, 250, 1)',
  // boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.75)',
  zIndex: "99999",
  width: "100%"
};

const headerStyle = {
  background: "#fff",
  // color: '#000',
  color: "#00A699",
  // display: 'flex',
  // alignItems: 'center',
  // justifyContent: 'space-between',
  fontSize: "2rem",
  padding: "20px",
  minHeight: "50px",
  height: "50px"
};

const headerText = {
  // position: 'absolute',
  // left: '50%',
  textTransform: "capitalize",
  transform: "translate(-50%, 0)"
  // padding: '25px',
};

const containerStyle = {
  mini: {
    height: "40vh",
    width: "40vw"
  },
  small: {
    height: "55vh",
    width: "55vw"
  },
  "mini-light": {
    height: "35vh",
    width: "25vw"
  },
  medium: {
    height: "70vh",
    width: "70vw"
  },
  large: {
    height: "80vh",
    width: "80vw"
  },
  xlarge: {
    height: "90vh",
    width: "90vw"
  },
  default: {
    height: "85.86525759577279vh",
    width: "67.1875vw"
  },
  //Invite User Modal
  "small-list": {
    height: "65vh",
    width: "25vw"
  },

  format: {
    height: "29vh",
    width: "20vw"
  },
  "color-picker": {
    height: "55vh",
    width: "20.5vw"
  },
  // for tree //commom/Tree
  "custom-mini": {
    height: "28vh",
    width: "32vw"
  },

  // add node
  "custom-node": {
    height: "34.5vh",
    width: "20vw"
  }
};

class ModalContainer extends Component {
  render() {
    let size = this.props.size;
    let containerSize =
      size && size !== "custom"
        ? { ...containerStyle[size] }
        : { height: this.props.height, width: this.props.width };
    let modalDialogStyle = this.props.fullScreen
      ? modalFullDialog
      : { ...modalDialog, ...containerSize };
    // if (this.props.modalDialogStyle) {
    //   modalDialogStyle = {
    //     ...modalDialogStyle,
    //     ...this.props.modalDialogStyle
    //   };
    // }
    // console.log('doomed', this.props.open);
    return this.props.open ? (
      <div
        className="custom-modal-container"
        onWheel={ev => {
          ev.stopPropagation();
          // console.log("mouse wheel", ev);
        }}
      >
        <div className="modal-background" style={modalBackground} />
        <div
          role="dialog"
          className={`modal-dialog-content ${this.props.headerClass}`}
          style={modalDialogStyle}
        >
          {this.props.header !== undefined && (
            <header style={headerStyle}>
              <span style={headerText}>{this.props.header}</span>
            </header>
          )}
          {/* {this.props.extraIcons ? [1,2,3,4].map( i => <span className="option" style={{float: "right", display: "inline-block"}}>{i}</span>) : null} */}
          <div
            onClick={() => this.props.onClose()}
            className="option"
            style={{ float: "right", color: "#111" }}
          >
            <i className="fa fa-close" />
          </div>
          <div className="custom-modal-content">{this.props.children}</div>
          <footer></footer>
        </div>
      </div>
    ) : null;
  }
}

ModalContainer.propTypes = {
  children: PropTypes.element.isRequired,
  // header: PropTypes.string,
  size: PropTypes.string
};

ModalContainer.defaultProps = {
  headerClass: "",
  size: "large",
  onClose: () => {},
  fullScreen: false,
  extraIcons: false
};

export default ModalContainer;



// WEBPACK FOOTER //
// ./src/components/common/Modal/ModalContainer.js